import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {SlideshowSlidesOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/slideshow-slides-option';
import {SlideshowTransitionOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/slideshow-transition-option';

interface SlideshowSlideSectionProps {
  onClickTransitionColorFill(): void;
}

export function SlideshowSlideSection({...props}: SlideshowSlideSectionProps): ReactElement {
  return (
    <>
      <ContextualMenuHeadingOption id="text-slide-heading-option" text={window.i18next.t('pmwjs_slides')} />
      <SlideshowSlidesOption />
      <SlideshowTransitionOption
        onClickColorFill={(): void => {
          props.onClickTransitionColorFill();
        }}
      />
    </>
  );
}
